import React, { useMemo, useState } from 'react'
import { Form } from 'antd'
import { SociogramActionsContext, SociogramStateContext } from './sociogram-contexts'

export const SociogramContextProvider = ({ children }) => {
  const [form] = Form.useForm()
  const [selectedSurvey, setSelectedSurvey] = useState(null)
  const [dataResponseActiveSurvey, setDataResponseActiveSurvey] = useState(null)
  const [dataResponseCreateSociogram, setDataResponseCreateSociogram] =
    useState(null)
  const [arraySociogramsIds, setArraySociogramsIds] = useState(null)
  const [isDoneSociogram, setIsDoneSociogram] = useState(false)
  const [isLoadingResponse, setIsLoadingResponse] = useState(null)
  const [sociogramId, setSociogramId] = useState(null)
  const [sociogramState, setSociogramState] = useState(0)

  const stateValue = useMemo(() => ({
    form,
    selectedSurvey,
    dataResponseActiveSurvey,
    dataResponseCreateSociogram,
    arraySociogramsIds,
    isDoneSociogram,
    isLoadingResponse,
    sociogramId,
    sociogramState
  }), [
    form,
    selectedSurvey,
    dataResponseActiveSurvey,
    dataResponseCreateSociogram,
    arraySociogramsIds,
    isDoneSociogram,
    isLoadingResponse,
    sociogramId,
    sociogramState
  ])

  const actionsValue = useMemo(() => ({
    setSelectedSurvey,
    setDataResponseActiveSurvey,
    setDataResponseCreateSociogram,
    setArraySociogramsIds,
    setIsDoneSociogram,
    setIsLoadingResponse,
    setSociogramId,
    setSociogramState
  }), [])

  return (
    <SociogramStateContext.Provider value={stateValue}>
      <SociogramActionsContext.Provider value={actionsValue}>
        {children}
      </SociogramActionsContext.Provider>
    </SociogramStateContext.Provider>
  )
}

export default SociogramContextProvider
